import SisuPage from './SisuPage';
import SisuPageContainer from './SisuPage.container';

export default SisuPageContainer(SisuPage);

export { default as SisuPageSubHeader } from './SisuPageSubHeader';
export { default as SisuPageHeader } from './SisuPageHeader';
export { default as SisuPageFooter } from './SisuPageFooter';
export { default as SisuPageContent } from './SisuPageContent';
